import React from 'react'

const Advisor = () => {
  return (
<section className="w-full">
  {/* Full Background Image Section */}
  <div
    className="w-full h-[850px] bg-cover "
    style={{
      backgroundImage:
        "url('https://res.cloudinary.com/dzngpgki4/image/upload/v1744990021/image_21_gu9f1e.png')",
    }}
  ></div>

  {/* Box below the image */}
  <div
    className="w-full h-[223px] bg-[#152C24] rounded-b-[5px] md:px-20 md:pt-5 md:pb-5" 
  >
    <h1 className='text-white font-medium md:text-[48px]'>
    Professor PLO Lumumba 
    </h1>
    <h1 className='text-white font-extrabold md:text-[64px] md:mt-1'>
    Advisor
    </h1>
  </div>

  {/* Paragraph Section */}
  <div className="w-full bg-[#2E453D] px-6 md:px-20 py-16">
  <div className="text-white text-[32px] md:text-[48px] font-[500] leading-relaxed font-['Inter'] whitespace-pre-line">
  <p className="">
    Professor PLO Lumumba is the Founder of the PLO Lumumba Foundation and a consultant<br/>
    with Lumumba and Lumumba Advocates, a member of the Africa Justice Group (AJG).<br/>
  <p className='md:mt-10'>
  Prof. Lumumba whose full name is Patrick Loch Otieno Lumumba was born on 17th July<br/>
    1962 and raised in Usenge and Nairobi Kenya. He received his LL.B and LL.M Degrees<br/>
    in Law at the University of Nairobi, followed by a Doctor of Law (LL.D) in the Law of the<br/>
<p className='md:mt-10'>
Sea at the University of Ghent in Belgium. He holds honorary Doctorate degrees from<br/>
 <p className='md:mt-10'>
 the University of Cape Coast in Ghana and Bells University in Nigeria. He is an Advocate<br/>
    of the High Courts of Kenya and Tanganyika and a certified mediator. He is a Fellow of the<br/>
    Institute of Certified Public Secretaries of Kenya FCPS (K), a Fellow of the Kenya Institute<br/>
    of Management (FKIM) and Honorary Fellow of the African Academy of Sciences (FAAS). He<br/>
    is the Chairman of Farafina Investment Group in Monrovia, Liberia and Economic Strategic<br/>
    Growth and Development Initiative of Africa based in Nigeria.
 </p>
</p>
  </p>
  </p>

  <p className="">
    He is the former Director and Chief Executive Officer of the Kenya School of Law, a former Secretary and Chief Executive of the<br/>
    Constitution of Kenya Review Commission (CKRC) and a former Director and Chief Executive of the defunct Kenya Anti-Corruption<br/>
    Commission (KACC) now Ethics and Anti-Corruption Commission (EACC). He is a former lecturer at the University of Nairobi (UON),<br/>
    the United States International University (USIU Africa) and Widener University USA (Nairobi Summer School). A former and<br/>
    Founding Dean of the Kabarak University School of Law.
  </p>

  <p className="">
    He was the Distinguished Mwalimu Julius Nyerere Lecturer at the University of Dar es Salaam for 2014. He was the 11th Kwame<br/>
    Nkrumah Lecturer at the University of Cape Coast in Ghana in 2016. He was the 5th Abram Tiro Onkgopotse Lecturer at the<br/>
    University of Limpopo in South Africa for the year 2017. He was the Nelson Mandela Centenary Memorial Lecturer at Walter Sisulu<br/>
    University in South Africa in 2018. He has authored several books on diverse subjects. He was the 5th Apollo Milton Obote<br/>
    Memorial Lecturer in Kampala, Uganda and the 2nd Ray Phiri Memorial Lecturer at the University of Mpumalanga in South Africa.
  </p>

  <p className="">
    With several thousand speeches on diverse subjects delivered in and outside Kenya, Lumumba is recognized as one of the leading<br/>
    public speakers in Kenya and across the African Diaspora. Prof. Lumumba is also the founder of several organizations including the<br/>
    PLO Lumumba Foundation, a charitable organization that has been in operation since 1990, The Association of the Citizens Against<br/>
    Corruption (ACAC) and Movement for Dialogue and Non-Violence (MODAN). He has also been twice recognized as one of the 100<br/>
    most influential Africans.
  </p>
  <div className='md:mt-40 mt-10'></div>
</div>

  </div>
</section>

  )
}

export default Advisor